// TODO 需项目迁移
const TITLE_OF_UTL_MAP = {
  'h5-abroad-hybird/faq/started': '首次出价引导页（H5）',
  'h5-abroad-hybird/personal/paypal': '收款账号创建/修改页面（H5）',
  'h5-abroad-hybird/notice/seller-detail': '公告详情页(H5)'
}
function titleOfUrlMap() {
  if (process.server) return {}
  let $title = ''
  Object.keys(TITLE_OF_UTL_MAP).some((key) => {
    if (location.href.includes(key)) {
      $title = TITLE_OF_UTL_MAP[key]
      return true
    }
  })
  if (!$title) {
    return {}
  }
  return { $title }
}

export default titleOfUrlMap
